import { physicalItemFragment } from "../fragments/cart"

const createCartMutation = /* GraphQL */ `
    mutation createCart($createCartInput: CreateCartInput!) {
        cart {
            createCart(input: $createCartInput) {
                cart {
                    entityId
                    amount {
                        currencyCode
                        value
                    }
                    lineItems {
                        totalQuantity
                        physicalItems {
                            ...physicalItem
                        }
                    }
                }
            }
        }
    }
    ${physicalItemFragment}
`

export { createCartMutation }
